import {observer} from "mobx-react";
import {useStores} from "../../../Hooks";
import React, {useEffect, useState} from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import PanoramaFishEyeIcon from "@mui/icons-material/PanoramaFishEye";

const MultiChoiceQuestion = observer(({question, index})=> {
    const {generalStore, rtcStore, modalStore, surveyStore} = useStores();


    return (
        <>
            <div className="py-2 text-xs">{generalStore.translate('selectOneOption')}:</div>
            <div className="flex flex-col justify-between items-center gap-2">
                {question.Options.map(option => (
                    <div
                        key={option}
                        onClick={() =>{ question.SelectedOption = option.OptionId}}
                        className={`w-full h-11 pl-4 rounded-xl outline outline-1 outline-gray-200 outline-offset-[-1px] flex items-center  cursor-pointer flex flex-row gap-2 ${(question.SelectedOption === option.OptionId) ?'bg-classic-button-normal text-classic-button-normal-text':'hover:bg-background-hover'}`}
                    >
                        {question.SelectedOption === option.OptionId ?<CheckCircleOutlineIcon sx={{ fontSize: 20 }}/> :<PanoramaFishEyeIcon sx={{ fontSize: 20 }}/>}
                        <span className="text-sm font-normal leading-5 text-center font-sans">{option.Text[surveyStore.currentLanguage]}</span>
                    </div>
                ))}
            </div>
        </>
    );
});

export default MultiChoiceQuestion;
